import type { Option } from 'src/components/SelectBox';

export type DayOption = { value: number; label: string };

export const days: DayOption[] = [
  { value: 0, label: 'Sun' },
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tues' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thur' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
];

export const timeOptions: Option[] = Array.from({ length: 24 * 2 }).map(
  (_, i) => {
    const hour = Math.floor(i / 2);
    const minute = i % 2 === 0 ? '00' : '30';
    const ampm = hour < 12 ? 'am' : 'pm';
    const displayHour = ((hour + 11) % 12) + 1;
    const label = `${displayHour}:${minute}${ampm}`;
    const value = `${hour.toString().padStart(2, '0')}:${minute}`;
    return { label, value };
  },
);

export const timezoneOptions: Option[] = [
  { value: 'contact-local', label: "Contact's Local Timezone" },
  { value: 'America/Los_Angeles', label: 'Pacific Time' },
  { value: 'America/Denver', label: 'Mountain Time' },
  { value: 'America/Chicago', label: 'Central Time' },
  { value: 'America/New_York', label: 'Eastern Time' },
];
